import PropTypes from 'prop-types';
// biome-ignore lint/correctness/noUnusedImports: existing error
import React from 'react';
import {FilterGroups} from '~/GalleryPB/FilterGroups';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';

export const FiltersDrawer = (props) => {
  const {handleCancelClick, handleApplyClick, onFilterToggle, filters, onPremiumInfoClick} = props;

  return (
    <>
      <div
        className={`gallery__filters-sidebar ${props.open ? 'open' : ''}`}
        data-qa-id="galleryFiltersDrawer"
      >
        <div className="gallery__filters-drawer__main-content-wrapper">
          <div className="gallery__filters-drawer__header">
            <Typography variant="header4" as="h2">
              Filters
            </Typography>
            <Button
              variant="transparent"
              size="small"
              data-qa-id="galleryFiltersDrawerCloseButton"
              onClick={() => handleApplyClick()}
            >
              <CloseLineIcon />
            </Button>
          </div>
          <div className="gallery__filters-drawer__filter-groups-wrapper">
            <FilterGroups
              filters={filters}
              onFilterToggle={onFilterToggle}
              onPremiumInfoClick={onPremiumInfoClick}
            />
          </div>
          <div className="gallery__filters-drawer__filters-bottom-fade" />
        </div>
        <div className="gallery__filters-drawer__cta-group">
          <div className="button-group--expand">
            <Button
              size="large"
              variant="secondary"
              className="button-group-item"
              data-qa-id="galleryFiltersDrawerCancelChangesButton"
              onClick={handleCancelClick}
            >
              Cancel
            </Button>
            <Button
              size="large"
              variant="primary"
              className="button-group-item"
              data-qa-id="galleryFiltersDrawerApplyChangesButton"
              onClick={() => handleApplyClick()}
            >
              Apply
            </Button>
          </div>
        </div>
      </div>
      {/** biome-ignore lint/a11y/noStaticElementInteractions: existing error */}
      {/** biome-ignore lint/a11y/useKeyWithClickEvents: existing error */}
      <div
        onClick={() => handleApplyClick()}
        className={`gallery__filters-overlay ${props.open ? 'open' : ''}`}
        data-qa-id="galleryFiltersDrawerOverlay"
      />
    </>
  );
};

FiltersDrawer.propTypes = {
  handleCancelClick: PropTypes.func,
  handleApplyClick: PropTypes.func,
  onFilterToggle: PropTypes.func,
  filters: PropTypes.object.isRequired,
  onPremiumInfoClick: PropTypes.func,
};
